const colorFn = key => {
  switch (key) {
    case "SUSCEPTIBLE":
      return "#777";
    case "INFECTED":
      return "#c60";
    case "SEVERE_CASE":
      return "#900";
    case "RECOVERED":
      return "#979";
    case "DIED":
      return "black";
    case "IMMUNO":
      return "#5389AF";
    case "HOSPITALIZED":
    default:
      return "green";
  }
};

export default colorFn;
